export {
  getConsent,
  setConsent,
  shouldBlockEndpointWithConsent,
} from './consent'
